import { SortParams } from '../../typings/grid';
import {
    FilterParams,
    Marketer,
    MarketersPageStates
} from '../../typings/marketers';

export const FETCH_MARKETERS_DATA = 'FETCH_MARKETERS_DATA';
export type FETCH_MARKETERS_DATA = typeof FETCH_MARKETERS_DATA;

export const FILTER_MARKETERS = 'FILTER_MARKETERS';
export type FILTER_MARKETERS = typeof FILTER_MARKETERS;

export const CHANGE_MARKETERS_PAGE_STATUS = 'CHANGE_MARKETERS_PAGE_STATUS';
export type CHANGE_MARKETERS_PAGE_STATUS = typeof CHANGE_MARKETERS_PAGE_STATUS;

export const UPDATE_MARKETERS_DATA = 'UPDATE_MARKETERS_DATA';
export type UPDATE_MARKETERS_DATA = typeof UPDATE_MARKETERS_DATA;

export const CHANGE_MARKETERS_FILTER_PARAMS = 'CHANGE_MARKETERS_FILTER_PARAMS';
export type CHANGE_MARKETERS_FILTER_PARAMS = typeof CHANGE_MARKETERS_FILTER_PARAMS;

export const SORT_MARKETERS = 'SORT_MARKETERS';
export type SORT_MARKETERS = typeof SORT_MARKETERS;

interface FetchMarketersAction {
    type: FETCH_MARKETERS_DATA;
}

export interface FilterMarketersAction {
    type: FILTER_MARKETERS;
}

export interface SetMarketersPageStatusAction {
    type: CHANGE_MARKETERS_PAGE_STATUS;
    status: MarketersPageStates;
}

export interface UpdateMarketersDataAction {
    type: UPDATE_MARKETERS_DATA;
    marketers: Marketer[];
    sortParams?: SortParams;
}

export interface ChangeMarketersFilterParamsAction {
    type: CHANGE_MARKETERS_FILTER_PARAMS;
    params: FilterParams;
}

export interface SortMarketersAction {
    type: SORT_MARKETERS;
    sortParams: SortParams;
}

export function fetchMarketers(): FetchMarketersAction {
    return {
        type: FETCH_MARKETERS_DATA
    };
}

export function filterMarketers(): FilterMarketersAction {
    return {
        type: FILTER_MARKETERS
    };
}

export function setMarketersPageStatus(
    status: MarketersPageStates
): SetMarketersPageStatusAction {
    return {
        type: CHANGE_MARKETERS_PAGE_STATUS,
        status
    };
}

export function updateMarketersData(
    marketers: Marketer[],
    sortParams?: SortParams
): UpdateMarketersDataAction {
    return {
        type: UPDATE_MARKETERS_DATA,
        marketers,
        sortParams
    };
}

export function changeMarketersFilter(
    params: FilterParams
): ChangeMarketersFilterParamsAction {
    return {
        type: CHANGE_MARKETERS_FILTER_PARAMS,
        params
    };
}

export function sortMarketers(sortParams: SortParams): SortMarketersAction {
    return {
        type: SORT_MARKETERS,
        sortParams
    };
}

export type MarketersListAction =
    | FetchMarketersAction
    | SetMarketersPageStatusAction
    | UpdateMarketersDataAction
    | FilterMarketersAction
    | ChangeMarketersFilterParamsAction
    | SortMarketersAction;
